/**
 * Environment variable utility
 * 
 * In production, environment variables are injected at runtime via env-config.js
 * This utility provides a consistent way to access env vars in both development and production
 * 
 * Priority:
 * 1. window._env_ (runtime injection in production)
 * 2. process.env (build-time, works in development)
 * 3. Default fallback value
 */

/**
 * Gets an environment variable value
 * @param {string} key - The environment variable key (e.g., 'REACT_APP_API_URL')
 * @param {string} defaultValue - Default value if not found
 * @returns {string} The environment variable value
 */
export function getEnvVar(key, defaultValue = '') {
  // Check runtime injected env vars first (production)
  if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  
  // Fall back to process.env (development/build-time)
  if (process.env[key]) {
    return process.env[key];
  }
  
  // Return default value
  return defaultValue;
}

/**
 * Gets the API base URL
 * @returns {string} The API base URL
 */
export function getApiBaseUrl() {
  return getEnvVar('REACT_APP_API_URL', '/api');
}

/**
 * Gets the GraphBuilder API base URL
 * @returns {string} The GraphBuilder base URL
 */
export function getGraphBuilderBaseUrl() {
  return getEnvVar('REACT_APP_GRAPH_BUILDER_URL', '/gb');
}


